import { request } from 'src/api/request';

export const getNewEducation = async ({ id, queryParams }) => {
  return await request({
    url: `v1/hcp/${id}/education-network${queryParams}`,
    method: 'GET',
  });
};
